import axios from "axios";
import { notification, setAlert } from "./alert";
import {
  GET_LOADS,
  GET_LOAD,
  LOAD_ERROR,
  ADD_LOAD,
  PATCH_PICKUP,
  PICKUP_ERROR,
  PATCH_DROP,
  DROP_ERROR,
  DELETE_LOAD,
  DELETE_LOAD_ERROR,
  UPDATE_LOAD,
  UPDATE_LOAD_ERROR,
  LOAD_DOC_DELETE,
  LOAD_DOC_UPLOAD,
  RETURNED_SEARCHED_LOADS,
  RESET_SEARCHED_LOADS,
  INVOICE_CREATED,
  SELECT_LOAD,
  INVOICE_LOAD_FETCHED,
  MERGE_LOAD_DOCS,
  RESET_INVOICE_GENERATED, LOADS_FETCHING,
} from "./types";
import {requestDelete, requestGet, requestPatch, requestPost} from "../utils/request";

// import { proxy } from "../../package.json";

export const SERVER_ADDRESS = (() => {
  try {
    const { getBaseUrl } = require('../config');
    const base = getBaseUrl();
    if (base) return String(base).replace(/\/$/, '');
  } catch (e) { /* fall through */ }
  if (typeof window !== 'undefined' && window.location?.origin) {
    return window.location.origin;
  }
  return '';
})();
// Get current users loads
export const getLoads = (page = 0, limit = 100, module = "", search='') => async (dispatch, getState) => {
  // Coerce page/limit so a count/offset or 0 never becomes an unbounded page walk
  const safeLimit = Math.max(1, Number(limit) || 100);
  let page0 = Number(page);
  if (!Number.isFinite(page0) || page0 < 0) page0 = 0;
  page0 = Math.floor(page0);

  dispatch({
    type: LOADS_FETCHING,
    payload: { isLoadsFetching: true },
  });
  try {
    // Add cache-busting timestamp to avoid any intermediate caching
    const timestamp = Date.now();
    const { success, data } = await requestGet({
      uri: `/api/load/me?page=${page0 + 1}&limit=${safeLimit}&module=${module}&search=${search}&t=${timestamp}`
    });
    dispatch({
      type: LOADS_FETCHING,
      payload: { isLoadsFetching: false },
    });
    if (success) {
      // Reducer reads payload.loads.{load,total,totalPages,currentPage,limit} from the API body
      dispatch({
        type: GET_LOADS,
        payload: {
          loads: data,
          page: page0,
          limit: safeLimit,
          loading: false,
        },
      });
    } else {
      notification(data.message, 'error');
    }
  } catch (err) {
    dispatch({
      type: LOADS_FETCHING,
      payload: { isLoadsFetching: false },
    });
    dispatch(setAlert(err.message, "error"));
  }
};

export const deleteLoadDocument =
  (load_id, doc_type, doc_name) => async (dispatch) => {
    try {
      const url = `/api/load/remove/doc/${load_id}/${doc_type}/${doc_name}`;
      await axios.delete(url);
      dispatch({
        type: LOAD_DOC_DELETE,
        payload: { load_id, doc_type },
      });
    } catch (err) {
      dispatch(setAlert(err.message, "error"));
    }
  };

export const uploadLoadDocument =
  (load_id, doc_type, documents) => async (dispatch) => {
    try {
      const url = `/api/load/upload/load/${load_id}/${doc_type}`;
      const form = new FormData();
      for (let doc of documents) form.append(doc_type, doc);
      const response = await axios.patch(url, form);
      const { file_data } = response.data;
      dispatch({
        type: LOAD_DOC_UPLOAD,
        payload: { file_data, load_id, doc_type },
      });
    } catch (err) {
      dispatch(setAlert(err.message, "error"));
    }
  };

export const generateInvoice = (load_id, data) => async (dispatch) => {
  try {
    await axios.post("/api/invoice", {
      load_id,
      ...data,
    });
    dispatch({
      type: INVOICE_CREATED,
      payload: { load_id },
    });
  } catch (err) {
    dispatch(setAlert(err.message, "error"));
  }
};

export const searchLoads = (page = 0, limit = 15, search = "", module = "") => async (dispatch) => {
  try {
    const url = `/api/load/me?page=${page + 1
      }&limit=15&search=${search}&module=${module}`;
    const res = await axios.get(url);
    dispatch({
      type: RETURNED_SEARCHED_LOADS,
      payload: { data: res.data, page, limit, search },
    });
  } catch (err) {
    dispatch(setAlert(err.message, "error"));
  }
};

export const resetLoadsSearch =
  (listBarType = "") =>
    async (dispatch, getState) => {
      dispatch({ type: RESET_SEARCHED_LOADS });
      // const {
      //   load: { page, rowsPerPage },
      // } = getState();
      // dispatch(getLoads(+page, +rowsPerPage, listBarType));
    };

export const selectLoad = (input = null) => ({
  type: SELECT_LOAD,
  payload: input,
});

// Get post
export const getLoad = (id) => async (dispatch) => {
  try {
    const { data } = await axios.get(`/loads/${id}`);

    dispatch({
      type: GET_LOAD,
      payload: data,
    });
  } catch (err) {
    dispatch(setAlert(err.message, "error"));
  }
};

//add load
export const addLoad = (formData, callback) => async (dispatch, getState) => {
  try {
    const {data, success} = await requestPost({uri: '/api/load', body: formData})
    if(success){
      dispatch({
        type: ADD_LOAD,
        payload: data,
      });

      notification("Load Created")

      // Refresh the loads list to ensure consistency
      const {
        load: {
          rowsPerPage, page
        },
      } = getState();
      dispatch(getLoads(page, rowsPerPage, '', ''));

      if (callback) {
        callback(success, data)
      }
    } else {
      notification(data.message, 'error')
    }
  } catch (err) {
    dispatch(setAlert(err.message, "error"));
    console.log(err)
  }
};

export const updateLoad = (formData, module = '', callback) => async (dispatch, getState) => {
  try {
    console.log('🔍 [UPDATE-LOAD-ACTION] Action called with:', {
      formDataKeys: Object.keys(formData),
      formData: formData,
      module: module,
      note: 'No bucketFiles - using individual document fields only'
    });

    const form = new FormData();
    
    // Process each field
    for (const [key, data] of Object.entries(formData)) {
      if (key === '_id') continue; // Skip ID field
      if (key === 'bucketFiles') continue; // Do not send legacy bucketFiles to avoid overwriting
      
      const isArray = Array.isArray(data);
      const isNull = data === null;
      
      console.log(`🔍 [UPDATE-LOAD-ACTION] Processing field ${key}:`, {
        value: data,
        isArray: isArray,
        isNull: isNull,
        type: typeof data
      });
      
      // Handle document arrays properly - send them as JSON strings that backend can parse
      if (["rateConfirmation", "proofDelivery", "lumper", "accessorials", "accessorialsFiles"].indexOf(key) >= 0) {
        // Document arrays should be sent as JSON strings that backend can parse
        if (isArray && !isNull && data.length > 0) {
          // Send the entire array as a single JSON string
          const dataToSend = JSON.stringify(data);
          form.append(key, dataToSend);
          console.log(`📎 [UPDATE-LOAD-ACTION] Adding document array for ${key}:`, { count: data.length, data: dataToSend });
        } else {
          // No documents, send empty array
          form.append(key, '[]');
          console.log(`📎 [UPDATE-LOAD-ACTION] No documents for ${key}, sending empty array`);
        }
      } else if (["pickup", "drop"].indexOf(key) >= 0) {
        // Pickup/Drop are arrays of objects and must be JSON encoded for the backend to parse safely
        if (isArray && !isNull && data.length > 0) {
          const dataToSend = JSON.stringify(data);
          form.append(key, dataToSend);
          console.log(`📦 [UPDATE-LOAD-ACTION] Adding array field ${key}:`, { count: data.length });
        } else {
          form.append(key, '[]');
          console.log(`📦 [UPDATE-LOAD-ACTION] No entries for ${key}, sending empty array`);
        }
      } else {
        // Non-document fields
        form.append(key, data);
        console.log(`📝 [UPDATE-LOAD-ACTION] Adding non-document field ${key}:`, data);
      }
    }

    // Add the load ID
    form.append('_id', formData._id);
    console.log(`📝 [UPDATE-LOAD-ACTION] Added load ID:`, formData._id);

    console.log('🔍 [UPDATE-LOAD-ACTION] Form data being sent:', {
      loadNumber: formData.loadNumber,
      documentFields: {
        rateConfirmation: formData.rateConfirmation?.length || 0,
        proofDelivery: formData.proofDelivery?.length || 0,
        lumper: formData.lumper?.length || 0,
        accessorials: formData.accessorials?.length || 0
      },
      note: 'Document arrays should now be preserved'
    });

    const { success, data } = await requestPatch({
      uri: "/api/load/modify",
      body: form
    });

    if (success) {
      console.log('✅ [UPDATE-LOAD-ACTION] Load updated successfully');
      notification('Load Updated');
      
      // Refresh the loads list
      const {
        load: {
          rowsPerPage, page
        },
      } = getState();
      // Await refetch to ensure UI state is in sync
      await dispatch(getLoads(page, rowsPerPage, module));

      // Fire a global event so any listeners can refetch as well (cross-view)
      try { window.dispatchEvent(new CustomEvent('loadUpdated')); } catch (_) {}
      
      // Inform caller of success
      if (typeof callback === 'function') {
        try { callback(true, data); } catch (_) {}
      }
      return data;
    } else {
      const message = data?.message || "Server error while modifying load";
      console.error("❌ [UPDATE-LOAD-ACTION] Failed to update load:", message);
      notification(message, "error");
      if (typeof callback === "function") {
        try { callback(false, data || { message }); } catch (_) {}
      }
      return { success: false, data: data || { message } };
    }
  } catch (error) {
    const message = error?.message || "Server error while modifying load";
    console.error("❌ [UPDATE-LOAD-ACTION] Error updating load:", error);
    notification(message, "error");
    if (typeof callback === "function") {
      try { callback(false, { message }); } catch (_) {}
    }
    return { success: false, data: { message } };
  }
};

export const downloadDocuments = (file_name) => {
  axios({
    url: "/api/load/download/" + file_name,
    method: "GET",
    responseType: "blob",
  }).then((res) => {
    const parts = res.config.url.split("/");
    const name = parts[parts.length - 1];
    const url = window.URL.createObjectURL(new Blob([res.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", name);
    document.body.appendChild(link);
    link.click();
  });
};

//add pickup

//patch pickup
export const patchPickup = (load_id, pickup) => async (dispatch) => {
  try {
    const res = await axios.patch(
      `/api/load/pickup?load_id=${load_id}`,
      pickup
    );
    dispatch({
      type: PATCH_PICKUP,
      payload: res.data,
    });
  } catch (err) {
    dispatch(setAlert(err.message, "error"));
  }
};

//patch drop
export const patchDrop = (load_id, drop) => async (dispatch) => {
  try {
    const res = await axios.patch(`/api/load/drop?load_id=${load_id}`, drop);
    dispatch({
      type: PATCH_DROP,
      payload: res.date,
    });
  } catch (err) {
    dispatch(setAlert(err.message, "error"));
  }
};

// Delete a load
export const deleteLoad = (load_id, callback) => async (dispatch) => {
  try {
    const { success, data } = await requestDelete({ uri: '/api/load', body: { data: { load_id: load_id } } })
    notification(data.message, success ? 'success' : 'error');
    if (success) {
      dispatch({
        type: DELETE_LOAD,
        payload: load_id,
      });
    }
    callback && callback(success, data)
  } catch (err) {
    notification(err.message, 'error')
  }
};

export const mergeDocuments = (data, headers) => async (dispatch) => {
  try {
    const res = await axios.post(`/api/load/invoice/merge_docs`, data, headers);
    console.log("Response :", res);
    dispatch({
      type: MERGE_LOAD_DOCS,
      payload: res.data,
    });
  } catch (err) {
    dispatch(setAlert(err.message, "error"));
  }
};

export const resetInvoiceGenerated = () => async (dispatch) => {
  try {
    dispatch({
      type: RESET_INVOICE_GENERATED,
      payload: null,
    });
  } catch (err) {
    dispatch(setAlert(err.message, "error"));
  }
};

// Get open board loads (available for bidding)
export const getOpenBoardLoads = (page = 0, limit = 50, filters = {}) => async (dispatch) => {
  dispatch({
    type: LOADS_FETCHING,
    payload: { isLoadsFetching: true },
  });
  try {
    const { getBabylonianServerUrl } = require('../config');
    const response = await axios.post(`${getBabylonianServerUrl()}/fetchOpenBoardLoads`, {
      pageIndex: page,
      pageSize: limit,
      ...filters
    });

    const { data, totalResults } = response.data;
    
    dispatch({
      type: LOADS_FETCHING,
      payload: { isLoadsFetching: false },
    });
    dispatch({
      type: GET_LOADS,
      payload: {
        loads: data,
        page,
        limit,
        loading: false,
        loads_pagination: {
          total: totalResults,
          currPage: page
        }
      }
    });
  } catch (err) {
    dispatch({
      type: LOADS_FETCHING,
      payload: { isLoadsFetching: false },
    });
    console.error('Error fetching loads from Babylonian Gate:', err);
    dispatch(setAlert('Unable to fetch available loads. Please check if the load board service is running.', "error"));
  }
};

// Get my bids (loads I've bid on)
export const getMyBids = (page = 0, limit = 50) => async (dispatch) => {
  dispatch({
    type: LOADS_FETCHING,
    payload: { isLoadsFetching: true },
  });
  try {
    const { success, data } = await requestGet({
      uri: `/api/load/bids?page=${page + 1}&limit=${limit}`
    });
    
    dispatch({
      type: LOADS_FETCHING,
      payload: { isLoadsFetching: false },
    });
    
    if (success) {
      dispatch({
        type: GET_LOADS,
        payload: {
          loads: data,
          page,
          limit,
          loading: false,
          loads_pagination: {
            total: data.length,
            currPage: page
          }
        }
      });
    }
  } catch (err) {
    dispatch({
      type: LOADS_FETCHING,
      payload: { isLoadsFetching: false },
    });
    dispatch(setAlert(err.message, "error"));
  }
};

// Place a bid on a load
export const placeBid = (loadId, bidAmount, notes = '') => async (dispatch) => {
  try {
    const { success, data } = await requestPost({
      uri: '/api/load/bid',
      body: {
        loadId,
        bidAmount,
        notes
      }
    });

    if (success) {
      notification('Bid placed successfully');
      // Refresh both open board and my bids
      dispatch(getOpenBoardLoads(0, 50));
      dispatch(getMyBids(0, 50));
    } else {
      notification(data.message, 'error');
    }
  } catch (err) {
    dispatch(setAlert(err.message, "error"));
  }
};

// Counter bid on a load
export const counterBid = (loadId, bidAmount, notes = '') => async (dispatch) => {
  try {
    const { success, data } = await requestPost({
      uri: '/api/load/counter-bid',
      body: {
        loadId,
        bidAmount,
        notes
      }
    });

    if (success) {
      notification('Counter bid placed successfully');
      // Refresh my bids
      dispatch(getMyBids(0, 50));
    } else {
      notification(data.message, 'error');
    }
  } catch (err) {
    dispatch(setAlert(err.message, "error"));
  }
};
